import React from "react";
import { PaymentType } from "@wayke-se/ecom";
import { accessoryTotalPrice, formatPrice } from "./utils/helpers";
import { getPaymentMethodTitle, getLoanDetails, getLoanInformation, } from "./utils/payment";
import { getVehicleFullTitle } from "./utils/trade-in-car";
import { getRetailerInformation } from "./utils/retailer";
import CartItem from "./ecom-cart-item";
export default (props) => {
    const [isExtended, setIsExtended] = React.useState(false);
    let displayRetailerName = true;
    if (!!props.orderOptions &&
        props.orderOptions.requiresDealerSelection() &&
        !props.dealer)
        displayRetailerName = false;
    const cartContent = [];
    const hasLoan = props.data.payment.paymentType &&
        props.data.payment.paymentType === PaymentType.Loan &&
        props.data.payment.hasAcceptedLoanDetails;
    const hasInsurance = props.data.insurance.wantsToSeeInsuranceOptions &&
        props.data.insurance.hasAddedInsurance &&
        props.data.insurance.personalNumber &&
        props.data.insurance.expectedDrivingDistance &&
        props.insuranceOptions !== null;
    const hasTradeIn = props.data.tradeInCar.wantsToDefineTradeIn &&
        props.data.tradeInCar.hasProvidedTradeInInfo &&
        props.data.tradeInCar.hasTradeInCar &&
        props.data.tradeInCar.registrationNumber &&
        props.vehicleLookup !== null;
    const hasAccessories = props.data.chosenAccessories.ids.length > 0;
    if (hasLoan) {
        const loanDetails = getLoanDetails(props.orderOptions, props.paymentLookup);
        const loanInformation = getLoanInformation(props.orderOptions);
        const loanPrice = loanDetails ? loanDetails.getCosts().monthlyCost : "";
        cartContent.push({
            title: getPaymentMethodTitle(PaymentType.Loan),
            description: loanInformation.name,
            price: loanPrice,
            unit: loanInformation.unit,
            addons: [],
        });
    }
    if (hasInsurance) {
        const insuranceOption = props.insuranceOptions.getInsuranceOption();
        const addons = insuranceOption.addons
            .filter((a) => props.data.insurance.addons.includes(a.name))
            .map((a) => ({
            title: a.title,
            price: a.monthlyPrice,
            unit: "kr/mån",
        }));
        cartContent.push({
            addons,
            title: "Försäkring",
            description: `${insuranceOption.brand.name} - ${insuranceOption.name}`,
            price: insuranceOption.price,
            unit: insuranceOption.unit,
        });
    }
    if (hasTradeIn) {
        const vehicleInformation = props.vehicleLookup.getVehicle();
        cartContent.push({
            title: "Inbytesbil",
            description: getVehicleFullTitle(props.data.tradeInCar.registrationNumber, vehicleInformation),
            price: null,
            valuation: Math.round(vehicleInformation.valuation / 100) * 100,
            unit: "kr",
            addons: [],
        });
    }
    if (hasAccessories) {
        const accessories = props.orderOptions.getAccessories();
        const chosenAccessories = accessories.filter((a) => props.data.chosenAccessories.ids.includes(a.id));
        const addons = chosenAccessories.map((a) => {
            const totalPrice = accessoryTotalPrice(a);
            return {
                title: a.name,
                price: totalPrice,
                unit: "kr",
            };
        });
        const accessoriesSumPrice = chosenAccessories.reduce((sum, accessory) => sum + accessoryTotalPrice(accessory), 0);
        cartContent.push({
            addons,
            title: "Tillbehör",
            price: accessoriesSumPrice,
            unit: "kr",
        });
    }
    const items = cartContent.map((c, index) => (React.createElement(CartItem, Object.assign({ key: index }, c))));
    const hasContent = items.length > 0;
    const handleCartClick = () => {
        if (!hasContent) {
            return;
        }
        setIsExtended(!isExtended);
    };
    const retailerInformation = getRetailerInformation(props.orderOptions);
    return (React.createElement("div", { "data-ecom-footer": "" },
        React.createElement("div", { "data-ecom-cart": "", className: isExtended && hasContent ? "is-extended" : "" },
            React.createElement("button", { className: `cart-header ${hasContent ? "" : "cursor-default"}`, onClick: handleCartClick },
                React.createElement("div", { className: "cart-header-img-section" },
                    React.createElement("div", { className: "cart-header-img", style: {
                            backgroundImage: `url(${props.vehicle.imageUrl})`,
                        } })),
                React.createElement("div", { className: "cart-header-content-section" },
                    React.createElement("div", { className: "cart-header-content-info" },
                        displayRetailerName && (React.createElement("div", { className: "cart-seller" }, retailerInformation.name)),
                        React.createElement("div", { className: "cart-header-title" },
                            React.createElement("span", { className: "font-medium" }, props.vehicle.title),
                            " ",
                            props.vehicle.shortDescription),
                        React.createElement("div", { className: "cart-header-price" },
                            formatPrice(props.vehicle.price),
                            " kr")),
                    hasContent && (React.createElement("div", { className: "cart-header-content-icon-container" },
                        React.createElement("div", { className: "cart-header-content-icon" }))))),
            hasContent && React.createElement("div", { className: "cart-body" }, items))));
};
